import { formatDistanceToNow } from "date-fns";
import React, { useState } from "react";
import { FaEdit, FaReply, FaPlus, FaMinus } from "react-icons/fa"; // Import icons

export const Comment = ({
  comment,
  onEdit,
  onReply,
  scriptUserInfo,
  handleCommentDelete,
  commentLoading,
  commentformattedTimes,
}) => {
  const [replyText, setReplyText] = useState("");
  const [showReplyInput, setShowReplyInput] = useState(false);
  const [showChildren, setShowChildren] = useState(true);

  const [editMode, setEditMode] = useState(false);
  const [editedComment, setEditedComment] = useState(comment.comments);

  const handleReply = () => {
    setShowReplyInput(!showReplyInput);
  };

  const handleReplyTextChange = (event) => {
    setReplyText(event.target.value);
  };

  const handleReplySubmit = (uuid) => {
    onReply(uuid, replyText);
    setReplyText("");
    if (replyText !== "") {
      setShowReplyInput(!showReplyInput);
    }
  };

  const handleEdit = () => {
    setEditMode(!editMode);
  };

  const handleEditChange = (event) => {
    setEditedComment(event.target.value);
  };

  const handleEditSubmit = () => {
    onEdit(comment.uuid, editedComment);
    setEditMode(!editMode);
  };

  return (
    <div
      style={{ marginLeft: "20px", marginTop: "10px" }}
      className="commentContainer my-8"
    >
      <div className="flex space-x-3 pb-2">
        <div>
          <img
            className="w-10 h-10 rounded-full"
            src={`https://i.pravatar.cc/150?u=a042581f4e29026704d`}
            alt="Rounded avatar"
          />
        </div>
        <div>
          <div className="flex items-center space-x-2">
            <p id={comment?.uuid} className="text-sm">
              {comment?.script_user?.username}
            </p>
            <p className="text-[11px] text-gray-500">
              {" "}
              {formatDistanceToNow(new Date(comment?.updatedAt), {
                addSuffix: true,
              })}
            </p>
          </div>
          {/* {console.log(comment)} */}
          <div className="pl-3">
            <div className="pl-5 ">
              <div
                className="text-sm w-[400px] break-words"
                id={comment?.user_uuid}
              >
                {editMode ? (
                  <>
                    <input
                      type="text"
                      className="outline-blue-300 border-[1px] pl-2 py-[1px] ml-2"
                      value={editedComment}
                      onChange={handleEditChange}
                    />
                    <button
                      className="bg-blue-500 hover:bg-blue-700 text-white text-sm ml-2 py-[4px] px-4 rounded"
                      onClick={handleEditSubmit}
                    >
                      Update
                    </button>
                  </>
                ) : (
                  <>{comment?.comments}</>
                )}
                {comment?.user_uuid == scriptUserInfo?.uuid && (
                  <>
                    <i
                      class="fa-regular fa-pen-to-square pl-3 text-[12px] cursor-pointer "
                      title="Edit"
                      id={comment.uuid}
                      onClick={handleEdit}
                    ></i>
                    <i
                      class="fa-solid fa-trash pl-2 text-[12px] cursor-pointer "
                      title="Delete"
                      id={comment.uuid}
                      onClick={() => handleCommentDelete(comment.uuid)}
                    ></i>
                  </>
                )}
              </div>

              <div className="flex space-x-2 items-center ">
                <p
                  onClick={handleReply}
                  id={comment.uuid}
                  style={{ cursor: "pointer" }}
                  className="text-[12px]"
                >
                  <i className="fa-regular text-[12px] pt-3 fa-message pr-1"></i>
                  Reply
                </p>
              </div>
              <p>
                {comment.ChildComments.length > 0 && (
                  <span
                    onClick={() => setShowChildren(!showChildren)}
                    style={{ cursor: "pointer" }}
                  >
                    {showChildren ? (
                      <span className="text-[14px] text-gray-500">
                        hide replies
                      </span>
                    ) : (
                      <span className="text-[14px] text-gray-500">
                        view replies
                      </span>
                    )}
                  </span>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>

      {showReplyInput && (
        <div style={{ marginLeft: "20px", marginTop: "2px" }}>
          <input
            type="text"
            className="outline-blue-300 border-[1px] pl-2 py-[1px] ml-2"
            value={replyText}
            onChange={handleReplyTextChange}
            placeholder="Enter your reply"
          />

          <button
            className={`bg-blue-500 hover:bg-blue-700 text-white text-sm ml-2 py-[4px] px-4 rounded ${
              commentLoading && "flex"
            } `}
            id={comment.uuid}
            onClick={() => handleReplySubmit(comment.uuid)}
          >
            {commentLoading && (
              <>
                <div role="status" className="pr-2 ">
                  <svg
                    aria-hidden="true"
                    className="inline w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 fill-blue-500"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentFill"
                    />
                  </svg>
                  <span className="sr-only">Loading...</span>
                </div>
              </>
            )}
            Reply
          </button>
          {/* <button>Reply</button> */}
        </div>
      )}
      {showChildren &&
        comment.ChildComments &&
        comment.ChildComments.length > 0 && (
          <div style={{ marginLeft: "20px" }}>
            {comment.ChildComments.map((child) => (
              <Comment
                key={child.uuid}
                comment={child}
                onEdit={onEdit}
                onReply={onReply}
                scriptUserInfo={scriptUserInfo}
                handleCommentDelete={handleCommentDelete}
              />
            ))}
          </div>
        )}
    </div>
  );
};

// Comments component to render all comments
export const Comments = ({
  comments,
  onEdit,
  onReply,
  scriptUserInfo,
  handleCommentDelete,
  commentLoading,
}) => {
  return (
    <div>
      {comments &&
        comments.map((comment) => (
          <Comment
            key={comment.uuid}
            comment={comment}
            onEdit={onEdit}
            onReply={onReply}
            scriptUserInfo={scriptUserInfo}
            handleCommentDelete={handleCommentDelete}
            commentLoading={commentLoading}
          />
        ))}
    </div>
  );
};
